import React, { FC } from 'react';
import cls from 'classnames';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { InformationItemProps } from './InformationItem.types';

export const classNames = getClassNames('sds-information-item', [
	'variant-icon',
	'variant-avatar',
	'variant-text',
	'left',
	'top',
	'right',
	'bottom',
	'avatar',
	'icon',
	'icon-text',
]);

const InformationItem: FC<InformationItemProps> = (props) => {
	const { className, variant } = props;

	return (
		
		<div className={cls(getRootClassListFromProps(classNames,props), className)}>
			{variant.type === 'icon' ? (
				<>
					<div className={classNames.icon}>{variant.icon}</div>
					<div className={classNames.iconText}>{variant.text}</div>
				</>
			) : (
				<>
					{variant.type === 'avatar' && <div className={classNames.avatar}>{variant.avatar}</div>}
					<div className={classNames.left}>
						<p className={classNames.top}>{variant.topLeftText}</p>
						{variant.bottomLeftText && <p className={classNames.bottom}>{variant.bottomLeftText}</p>}
					</div>
					<div className={classNames.right}>
						<p className={classNames.top}>{variant.topRightText}</p>
						{variant.bottomRightText && (
							<p className={classNames.bottom}>{variant.bottomRightText}</p>
						)}
					</div>
				</>
			)}
		</div>
	);
};

InformationItem.displayName = 'InformationItem';

export default InformationItem;
